export default "__VITE_PUBLIC_ASSET__c613fb38__"